const apiUrl = process.env.VUE_APP_API_URL
export default {
  CreateBooking: `${apiUrl}customer/stay/booking`,
  CreateCustomer: `${apiUrl}customers/register`,
  BookingEventRoom: `${apiUrl}cited/event/book/room`,
  ContactUs: `${apiUrl}cited/contact-us`,
  LoadRoomAvailable: `${apiUrl}room_available`,
  CheckRoomAvailable: `${apiUrl}customer/rooms/availability`,
  CheckRoomAvailableAtDate: `${apiUrl}customer/room/availability`,
  CreateNewCustomer: `${apiUrl}newCustomer`,
  CheckCustomerInfosByContact:(contact:string) =>`${apiUrl}customer/check/infos/${contact}`,
  LoadStayType: `${apiUrl}customer/stay/type`,
  LoadRoom: `${apiUrl}rooms`,
  LoadRoomType: `${apiUrl}customer/room/type/list`,
  LoadCited: `${apiUrl}cited/infos`,
  CreatePaymentType: `${apiUrl}treasury/payment/type/create`,
  LoadPaymentType: `${apiUrl}customer/payment/type`,
  LoadPayment: `${apiUrl}treasury/payment`,
  CreatePayment: `${apiUrl}treasury/payment/create`,
  LoadHeader: `${apiUrl}cms/header`,
  LoadHomePage: `${apiUrl}cms/homepage`,
  LoadFooter: `${apiUrl}cms/footer`,
  LoadRibbon: `${apiUrl}cms/header-ribbon`,
  LoadApartment: `${apiUrl}cms/apartment`,
  LoadEvent: `${apiUrl}cms/event`,
  LoadRestaurant: `${apiUrl}cms/restaurant`,
  LoadGallery: `${apiUrl}cms/gallery`,
  LoadHobbies: `${apiUrl}cms/hobbies`,
  LoadContact: `${apiUrl}cms/contact`,
}
